import React, { Component } from 'react';

import API from "@dndUtilities/system_api";

import SelectStringBox from "@components/input/selects/SelectStringBox"; 
import LoadingBox from "@components/input/LoadingBox";

type Props = {
  name: string;
  value: string;
  values: string[];
  special_feature_types: string[] | null;
  allowAny: boolean; 
  multiple: boolean;
  onChange: Function;
  disabled: boolean;
}

export interface State {
  special_feature_types: string[];
  loading: boolean;
}

const api = API.getInstance();

class SelectSpecialFeatureTypeBox extends Component<Props, State> {
  public static defaultProps = {
    allowAny: false,
    special_feature_types: null,
    disabled: false,
    multiple: false,
    value: "",
    values: []
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      special_feature_types: [],
      loading: true
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({ loading: true }, () => {
      api.getObjects({data_type: "special_feature"}).then((res: any[]) => {
        const special_feature_types: string[] = [];
        res.forEach((f: any) => {
          if (!special_feature_types.includes(f.type)) {
            special_feature_types.push(f.type);
          }
        });
        this.setState({ special_feature_types, loading: false });
      });
    });
  }

  render() {
    if (this.state.loading) {
      return (<LoadingBox />);
    } else {
      let features: string[] = [];
      if (this.props.allowAny) {
        features.push("Any");
      }
      features = [...features, ...this.state.special_feature_types];
      if (this.props.multiple) {
        return (
          <SelectStringBox 
            options={features}
            values={this.props.values} 
            name={this.props.name}
            disabled={this.props.disabled}
            multiple
            onChange={(values: string[]) => {
              this.props.onChange(values);
            }}
          />
        );
      } else {
        return (
          <SelectStringBox 
            options={features}
            value={this.props.value} 
            name={this.props.name}
            disabled={this.props.disabled}
            onChange={(value: string) => {
              this.props.onChange(value);
            }}
          />
        );
      }
    }
  }
}

export default SelectSpecialFeatureTypeBox;
